export type DownloadableFile = {
    id: string;
    filename: string;
};

export function buildFileDownloadUrl(file: DownloadableFile): string {
    return `/api/file/${file.id}/download/${encodeURIComponent(file.filename)}`;
}
